import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/home-pages/Home';
import Headers from './components/Headers';
import Service from './components/service-pages/Service';
import ServiceDetails from './components/service-pages/ServiceDetails';
import '@fontsource/manrope'; // Default weight is 400
import Industry from './components/industry-pages/Industry';
import IndustryDetail from './components/industry-pages/IndustryDetail';
import Contact from './components/Contact/Contact';

// import bg1 from './video/bg1.mp4';
// import bg2 from './video/bg2.mp4';


function App() {
  // const videoSources = [bg1, bg2, bg3];
  // const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  // useEffect(() => {
  //   const videoInterval = setInterval(() => {
  //     setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videoSources.length);
  //   }, 10000); 

  //   return () => clearInterval(videoInterval); 
  // }, [videoSources.length]);

  return (
    <>
      <div className="background-wrapper">
        {/* <video className="background-video" autoPlay muted loop>
          <source src={videoSources[currentVideoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        {/* <video autoPlay  loop muted>
          <source src={bg3}  type="video/mp4" />
        </video> */}

        {/* Content: headers, main content, etc. */}
        <div className="content-wrapper">
          <Headers />
          <main>
           
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="/home" element={<Home />} />
               <Route path="/service" element={<Service />} /> 
              
               <Route path="/industrie/industries" element={<Industry />} /> 
               <Route path="/industries/industries-details" element={<IndustryDetail />} /> 
               <Route path="/technology" element={<ServiceDetails />} />
               <Route path="/contact" element={<Contact />} /> 
            </Routes>
          </main>
        </div>
      </div>
    </>
  );
}

export default App;
